"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AmenityWrap = /** @class */ (function () {
    function AmenityWrap(s) {
        this.id = s.id;
        this.name = s.name;
        this.selected = s.selected;
        this.chosen = s.chosen;
        this.component = s.component;
        this.details = s.details;
    }
    Object.defineProperty(AmenityWrap.prototype, "isSelected", {
        get: function () {
            return this.selected;
        },
        enumerable: false,
        configurable: true
    });
    return AmenityWrap;
}());
var GroupWrap = /** @class */ (function () {
    function GroupWrap(s) {
        this.name = s.name;
        this.priority = s.priority;
        this.items = s.items.map(function (i) { return new AmenityWrap(i); });
    }
    Object.defineProperty(GroupWrap.prototype, "itemsSelected", {
        get: function () {
            return this.items.filter(function (i) { return i.isSelected; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GroupWrap.prototype, "anySelected", {
        get: function () {
            return this.itemsSelected.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    return GroupWrap;
}());
exports.default = GroupWrap;
//# sourceMappingURL=amenitiesTypes.js.map